export default {
    getModules: { method: 'get', url: 'emcadmin/modules' },
    postModules: { method: 'post', url: 'emcadmin/modules' },
    putModules: { method: 'put', url: 'emcadmin/modules/{id}' },
    deleteModules: { method: 'delete', url: 'emcadmin/modules/{id}' },
}
